import { useMemo } from 'react';

interface QueryParams {
  websiteId: string | null;
  returnUrl: string | null;
  /** `cloud` = número nuevo a Cloud API (roadmap#2097); sin valor = Coexistence. */
  mode: string | null;
}

export const useQueryParams = (): QueryParams => {
  return useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      websiteId: urlParams.get('websiteId'),
      returnUrl: urlParams.get('returnUrl'),
      mode: urlParams.get('mode'),
    };
  }, []);
};